export default __webpack_public_path__ + "static/media/deligoo.06ce97c7.svg";